
$(document).ready(function() {
  $('.product-form__input-item').click(function() {
    var clickedChild = $(this);
    var newValue = $(this).attr('data-val'); // You can replace this with your desired new value

    clickedChild.text(newValue); // Change the text of the clicked child

    var parentDiv = clickedChild.closest('.product-form__input'); // Find the parent div
    var newText = clickedChild.text(); // Get the new text from the clicked child

    parentDiv.find('.option-text').text(newText); // Display the new text in the parent div
  });
});
